import { useState } from 'react';
import { useMutation } from '@apollo/client';

import moment from 'moment';
import useToast from '../../../../customHooks/useToast';
import { GENERATE_EQUIFAX_METRO_2_FILE_PER_MONTH, MARK_AS_SUBMITTED_TO_EQUIFAX_BY_MONTH } from '../../../../graphql/admin_mutations';
import AdminModal from '../../../../components/AdminModal';

import InfoIconNew from '../../../../svgs/InfoIconNew';

import styles from './EquifaxGenerate.module.scss';
import AppDatePicker from '../../../../components/DatePicker';
import { DOWNLOAD_EQUIFAX_FILE } from '../../../../graphql/admin_queries';
import useCustomQuery from '../../../../network/useCustomQuery';
import DownloadIcon from '../../../../svgs/DownloadIcon';

const EquifaxReportModal = ({
  refetch,
  isShow,
  modalDetail = {},
  setModalDetail,
}: {
  refetch: any;
  isShow: boolean
  modalDetail: any;
  setModalDetail: any;
}) => {
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [monthToGenerateFor, setMonthToGenerateFor] = useState<any>('');
  const Toast = useToast();

  const [
    equifaxGenerateMetro2FileSpecificMonth,
    { loading: equifaxGenerateMetro2FileSpecificMonthLoading },
  ] = useMutation<
    { equifaxGenerateMetro2FileSpecificMonth: any },
    any
  >(GENERATE_EQUIFAX_METRO_2_FILE_PER_MONTH);

  const [
    equifaxUpdateSubmittedReportByMonth,
    { loading: equifaxUpdateSubmittedReportByMonthLoading },
  ] = useMutation<
    { equifaxUpdateSubmittedReportByMonth: any },
    any
  >(MARK_AS_SUBMITTED_TO_EQUIFAX_BY_MONTH);

  const [getEquifaxSignedMetro2File, getEquifaxSignedMetro2FileLoading] = useCustomQuery({
    query: DOWNLOAD_EQUIFAX_FILE,
    onError: () => {},
    onData: () => {},
  });

  const downloadDoc = async (fileUrl: string, fileName = '') => {
    try {
      const result = await fetch(fileUrl);
      const blob = await result.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `METRO2FILE_${fileName}_${new Date().toISOString()}.txt`;
      link.click();
    } catch (error) {
      console.log('error', error);
      // window.open(fileUrl, '_blank');
    }
  };

  const generateEquifaxFile = async (
  ) => {
    if (!equifaxGenerateMetro2FileSpecificMonthLoading) {
      try {
        const variables = {
          // rentPaymentId: id,
          monthYear: moment(monthToGenerateFor).format('yyyy-MM'),
        };
        const res = await equifaxGenerateMetro2FileSpecificMonth({ variables });
        if (
          res?.data?.equifaxGenerateMetro2FileSpecificMonth
          && res?.data?.equifaxGenerateMetro2FileSpecificMonth?.status === 200) {
          Toast.success(res?.data?.equifaxGenerateMetro2FileSpecificMonth?.message || 'Operation successful');
          refetch?.();
          setIsSuccessful(true);
          await downloadDoc(res?.data?.equifaxGenerateMetro2FileSpecificMonth?.url);
          setModalDetail({
            ...modalDetail,
            title: 'Operation successful',
            subTitle: 'Equifax metro2 file has been downloaded successfully.',
            s3Url: res?.data?.equifaxGenerateMetro2FileSpecificMonth?.url,
          });
        } else {
          Toast.error(res?.data?.equifaxGenerateMetro2FileSpecificMonth?.message || 'Operation Failed');
        }
      } catch (error) {
        if (error && error?.graphQLErrors && error?.graphQLErrors.length > 0) {
          Toast.error(error?.graphQLErrors[0]?.message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  const markFileAsSubmittedToEquifax = async (
  ) => {
    if (!equifaxUpdateSubmittedReportByMonthLoading) {
      try {
        const variables = {
          id: modalDetail?.id,
        };
        const res = await equifaxUpdateSubmittedReportByMonth({ variables });
        if (
          res?.data?.equifaxUpdateSubmittedReportByMonth
          && res?.data?.equifaxUpdateSubmittedReportByMonth?.status === 200) {
          Toast.success(res?.data?.equifaxUpdateSubmittedReportByMonth?.message || 'Operation successful');
          refetch?.();
          setIsSuccessful(true);
          setModalDetail({
            ...modalDetail,
            title: 'Operation successful',
            subTitle: 'Rent payment has been submitted to Equifax successfully.',
          });
        } else {
          Toast.error(res?.data?.equifaxUpdateSubmittedReportByMonth?.message || 'Operation Failed');
        }
      } catch (error) {
        if (error && error?.graphQLErrors && error?.graphQLErrors.length > 0) {
          Toast.error(error?.graphQLErrors[0]?.message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  const downloadEquifaxFile = async (
  ) => {
    if (!getEquifaxSignedMetro2FileLoading) {
      try {
        const variables = {
          id: modalDetail?.id,
        };
        const res = await getEquifaxSignedMetro2File({ variables });
        if (
          res?.data?.getEquifaxSignedMetro2File
          && res?.data?.getEquifaxSignedMetro2File?.status === 200) {
          Toast.success(res?.data?.getEquifaxSignedMetro2File?.message || 'Operation successful');
          refetch?.();
          setIsSuccessful(true);
          await downloadDoc(res?.data?.getEquifaxSignedMetro2File?.url);
          setModalDetail({
            ...modalDetail,
            title: 'Operation successful',
            subTitle: 'File downloaded successfully.',
          });
        } else {
          Toast.error(res?.data?.getEquifaxSignedMetro2File?.message || 'Operation Failed');
        }
      } catch (error) {
        if (error && error?.graphQLErrors && error?.graphQLErrors.length > 0) {
          Toast.error(error?.graphQLErrors[0]?.message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  const handleModalAction = (type: string) => {
    if (type === 'generateEquifaxFile') {
      generateEquifaxFile();
    }
    if (type === 'markEquifaxFileAsSubmitted') {
      markFileAsSubmittedToEquifax();
    }
    if (type === 'downloadEquifaxFile') {
      downloadEquifaxFile();
    }
  };

  const handleDateChange = (e) => {
    const thisDate = new Date(e);
    setMonthToGenerateFor(thisDate);
  };

  const getModalChildren = (type: string) => {
    if (type === 'markEquifaxFileAsSubmitted' && !isSuccessful) {
      return (
        <div onClick={downloadEquifaxFile} className={styles.btnCover}>
          <DownloadIcon />
          <strong className={styles.btnCover__text}>
            Click to download file again
          </strong>
        </div>
      );
    }

    if (type === 'generateEquifaxFile' && !isSuccessful) {
      return (
        <div className={styles.children}>
          <AppDatePicker
            value={monthToGenerateFor}
            placeholder="Start Date"
            onChange={handleDateChange}
            dateFormat="yyyy-MM"
            showMonthYearPicker
            maxDate={moment().subtract(1, 'month').format()}
          />
        </div>
      );
    }

    return (
      <div className={styles.children} />
    );
  };

  const handleCloseModal = () => {
    setModalDetail(null);
  };
  const loading = equifaxGenerateMetro2FileSpecificMonthLoading
  || equifaxUpdateSubmittedReportByMonthLoading
  || getEquifaxSignedMetro2FileLoading;
  return (
    <AdminModal
      headText={modalDetail?.title}
      subText={loading ? 'Processing...' : modalDetail?.subTitle}
      actionBtnName={modalDetail?.actionText || modalDetail?.action}
      handleModalAction={() => handleModalAction(modalDetail?.action)}
      topIcon={<InfoIconNew />}
      isShow={isShow}
      isActionBtnDisabled={modalDetail?.action === 'generateEquifaxFile' && !monthToGenerateFor}
      isSuccess={isSuccessful}
      isTopIcon
      onClickAway={handleCloseModal}
      onClose={handleCloseModal}
      isLoading={loading}
    >
      { getModalChildren(modalDetail?.action)}
    </AdminModal>
  );
};

export default EquifaxReportModal;
